// https://github.com/shadowwalker/next-pwa/blob/master/examples/web-push/pages/index.js
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import { WEB_PUSH_PUB } from '../../../config';
import { ADD_PUSH_SUBSCRIPTION } from '../../../helpers/graphql/notifications';
import graphQLClient from '../../../helpers/graphQLClient';

const base64ToUint8Array = base64 => {
  const padding = '='.repeat((4 - (base64.length % 4)) % 4);
  const b64 = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(b64);
  const outputArray = new Uint8Array(rawData.length);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export default function NotificationsToggle({ setNotificationPermission }) {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      'serviceWorker' in navigator &&
      window.workbox !== undefined
    ) {
      // run only in browser
      navigator.serviceWorker.ready.then(reg => {
        reg.pushManager.getSubscription().then(sub => {
          if (
            sub &&
            !(
              sub.expirationTime &&
              Date.now() > sub.expirationTime - 5 * 60 * 1000
            )
          ) {
            setSubscription(sub);
            setIsSubscribed(true);
          }
        });
        setRegistration(reg);
      });
    }
  }, []);

  const subscribeButtonOnClick = async event => {
    event.preventDefault();
    const sub = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: base64ToUint8Array(WEB_PUSH_PUB),
    });
    const variables = {
      pushSubscription: JSON.stringify(sub),
    };
    graphQLClient(ADD_PUSH_SUBSCRIPTION, variables).then(() =>
      console.log('Submitted push notification subscription to API'),
    );
    // call API to save subscription data on server in order to send web push
    // notification from server
    setSubscription(sub);
    setIsSubscribed(true);
    console.log('web push subscribed!');
    setNotificationPermission(true);
  };

  const unsubscribeButtonOnClick = async event => {
    event.preventDefault();
    if (subscription) await subscription.unsubscribe();
    // call API to delete or invalidate
    // subscription data on server
    const variables = {
      pushSubscription: '',
    };
    graphQLClient(ADD_PUSH_SUBSCRIPTION, variables).then(() =>
      console.log('Submitted push notification subscription to API'),
    );
    setSubscription(null);
    setIsSubscribed(false);
    console.log('web push unsubscribed!');
    setNotificationPermission(false);
  };

  return (
    <>
      <FormControlLabel
        labelPlacement="end"
        control={
          <Switch
            checked={isSubscribed}
            onChange={
              isSubscribed ? unsubscribeButtonOnClick : subscribeButtonOnClick
            }
            value="notificationPermission"
            color="primary"
          />
        }
        label="Enable notifications"
      />
    </>
  );
}
